import Component from 'vue-class-component'
import Vue from 'vue'
import UserHeader from '../shared/UserHeader.vue'
import CommentLikeButton from '../buttons/CommentLikeButton.vue'
import convoStore from '../../store/convo/convo-store'
import authStore from '../../store/auth/auth-store'
import { IConvo } from '../../model/convo'
import { IComment } from '../../model/comment'
import { IUser } from '../../model/user'
import ConvoCommentStatements from '@/components/statement/ConvoCommentStatements';

@Component({
  name: 'convoComments',
  props: ['comment', 'convo'],
  components: {
    'user-header': UserHeader,
    'comment-like-button': CommentLikeButton,
    'convo-comment-statements': ConvoCommentStatements,
  }
})
export default class ConvoComment extends Vue {
  mounted (): void {
    const convo: IConvo = this.$props['convo']
    const comment: IComment = this.$props['comment']

    this.$store.subscribe((mutation, state) => {
      console.log('ConvoComment mutation: type = %j', mutation.type)
      console.log('ConvoComment mutation: payload = %j', mutation.payload)
      console.log('ConvoComment mutation: this comment = %j', comment)
      if (mutation.type === 'convo/setIsAllJybed') {
        console.log('ConvoComment mutation: testing convo: %j', mutation.payload.convo)
        const updatedConvo = mutation.payload.convo as IConvo
        if (updatedConvo.id === convo.id && comment.meta && comment.meta.creator && comment.meta.creator.id === (authStore.user as IUser).id) {
          console.log('ConvoComment mutation: updating all jybed for convo %j and comment: %j', convo, comment)
          convoStore.dispatchSetCommentJybedForUser({ convo: convo, comment: comment })
        }
      }
      if (mutation.type === 'comment/setCreator') {
        console.log('ConvoComment mutation: testing comment: %j', mutation.payload.comment)
        const updatedComment = mutation.payload.comment as IComment
        if (updatedComment.id === comment.id) {
          console.log('ConvoComment mutation: fetching all jybed for: %j', comment)
          convoStore.dispatchFetchAllJybedForUser({ convo: convo, comment: comment })
        }
      }
    })
  }

  get isEditable() {
    return false;
  }
}
